import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	title: {
		'id': 'platform.title',
		'defaultMessage': 'Stog community',
	},
	description: {
		'id': 'platform.description',
		'defaultMessage': 'Stog harbors a community of dedicated and enthusiastic people. Proliferating information sharing is the key to a thriving ecosystem.',
	},
	labelIcon1: {
		'id': 'platform.icon1.label',
		'defaultMessage': 'Find partners',
	},

	labelIcon2: {
		'id': 'platform.icon2.label',
		'defaultMessage': 'Share knowledge',
	},

	labelIcon3: {
		'id': 'platform.icon3.label',
		'defaultMessage': 'Ask experts',
	},

	labelIcon4: {
		'id': 'platform.icon4.label',
		'defaultMessage': 'Advertise and sell your crops',
	},

	labelIcon5: {
		'id': 'platform.icon5.label',
		'defaultMessage': 'Create and test your own recipes',
	},

});


// WEBPACK FOOTER //
// ./src/components/LandingPlatform/messages.js